












import { Component, Vue } from 'vue-property-decorator'

@Component({
  props: {
    header: String
  }
})
export default class PochetteSection extends Vue {
}
